import React, { Component } from 'react';
import { verifyStateAndGetRedirectLocation } from './AuthenticationService';
import { withRouter } from 'react-router-dom';
import FullScreenLoadingComponent from '../Components/Loaders/FullScreenLoadingComponent';

class AuthenticateComponent extends Component {
  componentDidMount() {
    const redirectionLocation = verifyStateAndGetRedirectLocation();
    this.props.history.replace(redirectionLocation);
  }

  render() {
    return <FullScreenLoadingComponent />;
  }
}
export default withRouter(AuthenticateComponent);



// WEBPACK FOOTER //
// ./src/Authentication/AuthenticateComponent.js